import { HttpErrorResponse } from '@angular/common/http';
import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root',
})
export class ErrorFormatter {
  formatMessage(error: HttpErrorResponse): string {
    if (!error?.error?.error?.details) {
      return error.error.message ?? error.error.detail;
    }

    return Object.entries(error.error.error.details)
      .map(([key, value]) => `${key}: ${value}`)
      .join('</br>');
  }

  formatTitle(error: HttpErrorResponse, defaultTitle: string): string {
    return error?.error?.error?.message ?? defaultTitle;
  }
}
